import { render, staticRenderFns } from "./SingleBrandDashboard.vue?vue&type=template&id=7b26f688&scoped=true&"
import script from "./SingleBrandDashboard.vue?vue&type=script&lang=js&"
export * from "./SingleBrandDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SingleBrandDashboard.vue?vue&type=style&index=0&id=7b26f688&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b26f688",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VDivider,VRow,VSkeletonLoader})
